import { render, staticRenderFns } from "./forgotPWD.vue?vue&type=template&id=3a80ab10"
import script from "./forgotPWD.vue?vue&type=script&lang=js"
export * from "./forgotPWD.vue?vue&type=script&lang=js"
import style0 from "./forgotPWD.vue?vue&type=style&index=0&id=3a80ab10&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports